import {useConfirmationContext} from "@/contexts/ConfirmationContext";
import {useNotificationContext} from "@/contexts/NotificationContext";
import {Box, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";
import React from "react";
import {useNavigate} from "react-router-dom";
import {LoadingDotBox} from "@/components/Shared/LoadingBox.tsx";
import {createCustomerTeam, resolveCustomerTeam} from "@/services/customer.ts";
import TeamMembers from './TeamMembers';
import Utils from "@/components/Shared/Utils";

export default function TeamOwned({customer, user}: any) {
    const {setNotification} = useNotificationContext()
    const {setConfirmation} = useConfirmationContext()

    const navigate = useNavigate();
    const {data: team, refetch} = resolveCustomerTeam(user);

    async function handleActiveTeammate() {
        const payload = {
            owner: user?.email
        }

        const data = await createCustomerTeam(payload)

        if (data) {
            setNotification({
                message: 'Your teammate activated successful. Now you can manage them by add first member',
                open: true
            })
            await refetch()
        }
    }

    return (
        <Box p={2}>
            {team ? (
                <Box mb={2}>
                    <Utils.LayoutUtils.MainInformationFact>
                        <Box mb={2}>
                            <Typography fontSize={14} fontWeight={700} sx={{mb: 0.5}}>Team Members</Typography>
                            <Typography fontSize={14} color={grey[700]}>View and manage your teammates.</Typography>
                        </Box>
                        <Typography fontSize={20}
                                    fontWeight={600}>{team?.teammates?.length?.toLocaleString() || 0}</Typography>
                    </Utils.LayoutUtils.MainInformationFact>
                </Box>
            ) : (
                <Box mb={2}>
                    <Utils.LayoutUtils.MainInformationFact variant="alert">
                        <Typography mb={1} fontSize={13}>
                            Team setup is incomplete. Kindly complete the team information before proceeding.
                        </Typography>

                        <Utils.FormUtils.PrimaryButton disabled={!customer} onClick={() => setConfirmation({
                            dialog: {
                                title: `Active Teammate`,
                                description: `By enabling this, you'll unlock collaboration features for your team, allowing them to join your organization and access your services.`,
                            },
                            show: true,
                            callback: () => handleActiveTeammate()
                        })}>
                            Active Teammate
                        </Utils.FormUtils.PrimaryButton>
                    </Utils.LayoutUtils.MainInformationFact>
                </Box>
            )}
            <React.Suspense fallback={<LoadingDotBox/>}>
                <TeamMembers customer={customer} team={team} close={() => [refetch(), navigate("/account/organization#teams")]}/>
            </React.Suspense>
        </Box>
    )
}